const swiper = new Swiper("#swiper-opinion-carousel", {
	// slidesPerView: 3,
    // centeredSlides: true,
	// loop: true,
	spaceBetween: 16,
	loop: true,
	//slidesPerView: 1.6,
    //slidesOffsetBefore: 15,
	navigation: {
		nextEl: ".custom-swiper-button-next",
		prevEl: ".custom-swiper-button-prev",
	},

	pagination: {
		clickable: true,
		el: ".custom-swiper-pagination",
	},

	breakpoints: {
		320: {
			slidesPerView: 1,
		},
		560: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 2,
		},
		1024: {
            slidesPerView: 2,
		},
		1140: {
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
		},
		1320: {
            slidesPerView: 3,
		},
	},
});